<template>
  <base-card>
    <!-- <button class="btn" @click="goBack">Return</button> -->
    <h2>Member Details</h2>

    <div v-if="selectedMember" class="memberInfo">
      <li><b> Name:</b> {{ fullName }}</li>
      <li><b>Spouse:</b> {{ spouse }}</li>
      <li><b>Number in HouseHold:</b> {{ houseHold }}</li>
      <transition-group
        tag="li"
        enter-active-class="animate__animated animate__backInLeft "
        leave-active-class="animate__animated animate__backOutLeft "
      >
        <li v-if="connectionGroup">
          <b>Connection Group:</b> {{ connectionGroup }}
        </li>
      </transition-group>

      <li><b>Date first Contacted:</b> {{ dateFirstContact }}</li>
      <li>
        <b> Date Last Contacted:</b> {{ dateLastContact }}
        <ul>
          <h2>Notes</h2>
          <member-note
            v-for="note in member.notes"
            :key="note.id"
            :parentId="id"
            :noteId="note.id"
            :note="note.note"
          >
          </member-note>
        </ul>
      </li>

      <li>
        <select v-model="selectedGroupId">
          <option
            v-for="group in groups"
            :key="group.id"
            v-bind:value="group.id"
            :selected="group"
          >
            {{ group.groupName }}
          </option>
        </select>
      </li>
      <li>
        <button class="btn" @click="add">Add member to Group</button>
      </li>

      <textarea rows="5" v-model.trim="note"></textarea>
      <button class="btn" @click="addNote">Add a Note</button>
    </div>
    <div v-else>
      <button class="btn" @click="reloadMember">Load MemberDetails</button>
    </div>
  </base-card>
</template>

<script>  
   import {mapActions} from 'vuex';  


    export default {
         active: false,
         props: ['id'],

     data () {
       return {
         selectedMember: null,
         groups: [],
         note: "",
         selectedGroupId: "",
         options: { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' },
         showElement: true
       }
     },
        computed: {

          member() {
             return this.$store.getters['members/members'].find(m => m.id === this.id) 
          },

          groupsToLoad () {
            return this.$store.getters['groups/groups']
          },

          fullName() {
            if(this.selectedMember) {
              return this.selectedMember.firstName + ' ' + this.selectedMember.lastName;
            } else {
              return this.selectedMember
            }
            
          },
          spouse() {
            if(this.selectedMember) {
              return this.selectedMember.spouse;
            } else {
              return this.selectedMember
            }
            
          },
          houseHold() {
            if(this.selectedMember ) {
              return this.selectedMember.houseHold;
            } else {
              return this.selectedMember
            }
            
          },
          connectionGroup() {
           
               if( this.selectedMember && this.selectedMember.connectionGroup) {
               return this.selectedMember.connectionGroup.groupName;
               } 
                else {
                return 'No Group'
               }
              
          },
          dateFirstContact() {
              if(this.selectedMember) {
                  return this.selectedMember.dateFirstContact.toLocaleDateString("en-US",  this.options)
              } else {
                return 'Has not been contacted'
              }
          
          },
          dateLastContact() {
            if(this.selectedMember ) {
              return this.selectedMember.dateLastContact.toLocaleDateString("en-US",  this.options)
            } else {
              return 'Needs to be contacted'
            }

          },
          
          notes() {
            return this.selectedMember.notes
          }
          
        },
   

     created() {
      this.loadMembers();
      this.loadGroups();
      this.selectedMember = this.$store.getters['members/members'].find(m => m.id === this.id) 
      this.groups = this.$store.getters['groups/groups']
      if(this.groups === null || undefined) {
          this.active = true
      }
     },


     methods: {

        ...mapActions('groups', ['addToGroupAction']),
        goBack(){
                this.$router.go(-1);
              },

        async loadMembers() {
          await this.$store.dispatch('members/loadMembers')
        },
        async loadGroups() {
          await this.$store.dispatch('groups/fetchGroups')
        },

        
        reloadMember() {
          this.selectedMember = this.member
          this.groups = this.groupsToLoad
        },

        add() {
          const member = {
            id: this.selectedMember.id,
            firstName: this.selectedMember.firstName,
            lastName: this.selectedMember.lastName,
            groupId: this.selectedGroupId,
            
          }
          this.$store.dispatch('members/addGroupToMember', { memberId: member.id,  group: this.groups.find(g => g.id === member.groupId)});
          this.addToGroupAction(member);
          this.loadGroups();
           this.selectedMember = this.$store.getters['members/members'].find(m => m.id === this.id) 
         // this.$router.replace('/groups')
        },

        addNote(){
          this.$store.dispatch('members/addNoteToMember', {id: this.id, note: this.note})
           this.loadGroups();
        },

        setGroupId(id){
          this.selectedGroupId = id
        }


      }
    }
</script>

<style scoped>
.memberInfo {
  text-align: left;
}

.error {
  color: red;
}

input,
textarea {
  display: block;
  width: 100%;
  font: inherit;
  border: 1px solid #ccc;
  padding: 0.15rem;
}

input:focus,
textarea:focus {
  border-color: #3d008d;
  background-color: #faf6ff;
  outline: none;
}

li {
  list-style: none;
}
.liClass {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}

li {
  list-style: none;
  padding: 0.07rem;
  margin-bottom: 0.3rem;
}

.btn {
  background-color: cadetblue;
  /* color: #9a3f3f; */
  color: white;
  padding: 0.5rem;
  border: none;
  border-radius: 0.3rem;
  width: 11em;
  font-size: 1em;
  cursor: pointer;
}
.btnContainer {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
}

@media only screen and (max-width: 600px) {
  .liClass {
    margin: 0;
    display: flex;
    flex-direction: column;
  }
  ul {
    margin: 0;
    padding: 0;
  }
  .btnContainer {
    display: flex;
    border-bottom: 1px solid black;
    margin-bottom: 1rem;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.26);
  }
  .btn {
    width: 100%;
  }
}
</style>
